import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["pathname", "hasStagedChanges"];
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import LeaveTabModal from './LeaveTabModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ROOT_PATH = `/settings/${PortalIdParser.get()}`;
const TAB_ROUTES = {
  PROFILE_URL: `${ROOT_PATH}/user-preferences/profile`,
  EMAIL_URL: `${ROOT_PATH}/user-preferences/email`,
  CALLING_URL: `${ROOT_PATH}/user-preferences/calling`,
  CALENDAR_URL: `${ROOT_PATH}/user-preferences/calendar`,
  TASKS_URL: `${ROOT_PATH}/user-preferences/tasks`,
  SECURITY_URL: `${ROOT_PATH}/user-preferences/security`,
  AUTOMATION_URL: `${ROOT_PATH}/user-preferences/automation`
};
const UserProfileTabs = props => {
  const {
      pathname,
      hasStagedChanges
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [event, setEvent] = useState(null);
  const renderModal = () => {
    if (event && hasStagedChanges) {
      return /*#__PURE__*/_jsx(LeaveTabModal, {
        onConfirm: () => {
          window.location.href = event.target.value;
        },
        onReject: () => setEvent(null)
      });
    }
    return null;
  };
  const {
    PROFILE_URL,
    EMAIL_URL,
    CALLING_URL,
    CALENDAR_URL,
    TASKS_URL,
    SECURITY_URL,
    AUTOMATION_URL
  } = TAB_ROUTES;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [renderModal(), /*#__PURE__*/_jsxs(UITabs, Object.assign({
      defaultSelected: pathname,
      selected: pathname,
      use: "enclosed",
      onSelectedChange: e => {
        if (hasStagedChanges) {
          setEvent(e);
          e.preventDefault();
        }
      }
    }, rest, {
      children: [/*#__PURE__*/_jsx(UITab, {
        tabId: PROFILE_URL,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settings-ui-nav.userProfileTabs.profile"
        }),
        href: PROFILE_URL
      }), /*#__PURE__*/_jsx(UITab, {
        tabId: EMAIL_URL,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settings-ui-nav.userProfileTabs.email"
        }),
        href: EMAIL_URL
      }), /*#__PURE__*/_jsx(UITab, {
        tabId: CALLING_URL,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settings-ui-nav.userProfileTabs.calling"
        }),
        href: CALLING_URL
      }), /*#__PURE__*/_jsx(UITab, {
        tabId: CALENDAR_URL,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settings-ui-nav.userProfileTabs.calendar"
        }),
        href: CALENDAR_URL
      }), /*#__PURE__*/_jsx(UITab, {
        tabId: TASKS_URL,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settings-ui-nav.userProfileTabs.tasks"
        }),
        href: TASKS_URL
      }), /*#__PURE__*/_jsx(UITab, {
        tabId: SECURITY_URL,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settings-ui-nav.userProfileTabs.security"
        }),
        href: SECURITY_URL
      }), /*#__PURE__*/_jsx(UITab, {
        tabId: AUTOMATION_URL,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settings-ui-nav.userProfileTabs.automation"
        }),
        href: AUTOMATION_URL
      })]
    }))]
  });
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UserProfileTabs.defaultProps = {
  bordered: true
};
UserProfileTabs.propTypes = {
  pathname: PropTypes.string.isRequired,
  hasStagedChanges: PropTypes.bool,
  bordered: PropTypes.bool
};
export default UserProfileTabs;